export class AppStatusTimerExtension {
  id?: number;
  applicationStatusTimerId: number;
  createdDateTime: Date;
  timerExtensionDurationInSeconds: number;
}
